export default "__VITE_ASSET__0_epcnt6__"